import { fetchResource } from "../../util/fetch";
import { Service } from "../../service/device/setup";
import { UploadImageCard } from "../pictureupload/pictureupload";
import { BackgroundPicker } from "../backgroundpicker/backgroundpicker";
import { onCleanup } from "solid-js";

export function PictureManager(props) {
    const [theme, refetchTheme] = fetchResource(() => Service.getTheme(props.theme.uuid));
    const [backgroundImages, refetchImages] = fetchResource(() => Service.listBackgroundImages());
    const timeout = 1000 * 60; // One minute;
    var interval;
    function onDelete() {
        refetchImages();
        refetchTheme();
    }
    function onUploadComplete(uuid) {
        interval = setInterval(() => {
            Service.listBackgroundImages().then(myBackgroundImages => {
                if (myBackgroundImages.some(img => img.metadata.link === uuid)) {
                    refetchTheme();
                    refetchImages();
                    clearInterval(interval);
                }
            })
        }, 1000);

        setTimeout(() => {
            clearInterval(interval);
        }, timeout);
    };

    onCleanup(() => {
        clearInterval(interval);
    });
    return <>
        <UploadImageCard tag="user_background_image" backgroundImages={backgroundImages} onUploadComplete={onUploadComplete} />
        <BackgroundPicker theme={theme} backgroundImages={backgroundImages} onDelete={onDelete} />
    </>
}